<template>
  <div >
    <el-drawer @reload="$reloadHandle" title="退单" size="40%" :before-close="handleClose" :visible.sync="drawer"
               direction="rtl" append-to-body  custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">



        <template>
          <div>
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">
                <div class="d-header">
                  <div class=""  style="padding: 5px;border-bottom: 1px solid #ededed">
                    <i class="el-icon-info" style="color: #00c4b3;" />
                    <!-- {{ dataId ? '查看' : '新增' }}工单 -->
                    工单号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.orderNo }}</span>
                    <!-- 服务类型 -->
                    <span class="information">{{ formData.serverTypeName}}</span>
                    <!-- 工单状态 -->
                    <span class="information">
                      {{formData.stat == '1'?'登记':formData.stat == '2'?'发布':formData.stat == '5'?'已派网点':formData.stat == '6'?'网点已接单'
                      :formData.stat == '9'?'已派师傅':formData.stat == '10'?'师傅已接单':formData.stat == '11'?'已预约'
                        :formData.stat == '13'?'已出发':formData.stat == '17'?'已上门'
                        :formData.stat == '20'?'完工暂存':formData.stat == '61'?'已完工'
                        :formData.stat == '62'?'网点确定完工':formData.stat == '63'?'中心确定完工':formData.stat == '64'?'总部确定完工'
                          :formData.stat == '91'?'待结算':formData.stat == '92'?'结算驳回':formData.stat == '93'?'结算中止'
                              :formData.stat == '94'?'已结算':formData.stat == '97'?'申请关闭'
                                  :formData.stat == '98'?'挂起':formData.stat == '99'?'取消':formData.stat == '100'?'结束':''}}</span>
                    <!-- 紧急度 -->
                    <span class="information" v-if="formData.urger==0">一般</span>
                    <span class="information" v-else-if="formData.urger==1">紧急</span>
                    <span class="information" v-else-if="formData.urger==2">特急</span>
                    <span class="information" v-else>未知</span>
                  </div>
                </div>

<!--                <div v-if="formData.serviceType!=4 && formData.serviceType!=11 && formData.serviceType!=13">
                  <el-form-item label="退单原因:" label-width="100px" :readonly="true">
                    <el-select v-model="formData.returnId" placeholder="" style="width: 200px;" ref ="returnId">
                      <el-option v-for="item in returnData" :key="item.id" :label="item.returnName"
                                 :value="item.id"/>
                    </el-select>
                  </el-form-item>
                </div>
                <div v-if="formData.serviceType==4 || formData.serviceType==11 || formData.serviceType==13">
                  <el-form-item label="退单原因:" label-width="100px" :readonly="true">
                    <el-select v-model="formData.returnId" style="width: 8vw;" ref ="returnId" clearable filterable>
                      <el-option v-for="item in returnData" :key="item.id" :label="item.returnName"
                                 :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>-->

                <el-form-item label="退单原因:" label-width="100px" :readonly="true">
                  <el-select v-model="formData.returnId" style="width: 8vw;" ref ="returnId" clearable filterable>
                    <el-option v-for="item in returnData" :key="item.id" :label="item.returnName"
                               :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>


                <el-form-item label="备注:" label-width="100px">
                  <el-input class="annotate" type="textarea" :rows="5" placeholder="请输入内容" size="small" style="width: 90%"
                            v-model="formData.remark" clearable  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </template>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="orderFollowUp">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 关闭弹窗 -->

  </div>
</template>
<script>
import request from "@/router/axios";
import api from "../../api/projectApi";
export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi','param' ],
  components: {

  },
  created(){
    this.dataId= this.param?this.param.orderId?this.param.orderId:'':''
    this.showInRemark = this.param?this.param.showInRemark?this.param.showInRemark:'':''
    this.orderRemarkData.id = this.param?this.param.orderId?this.param.orderId:'':''
  },
  data() {
    return {
      show3: false,
      showInRemark:"",
      refuseOrderReasonShow:true,
      dataId: '',
      form2: {
        desc: '',
        name: "",
      },
      showOrderPop: false,
      isSendApp:false,
      drawer: true,
      formData: {
        acceptValue:1,
        refuseOrderReason:null,
        cancelReason:null,
        remark:'',
        returnId:null,
        returnName:null,
      },
      dispatchStats: [],
      refuseOrderReasonList:[],
      orderRemarkData:{}
    }
  },
  mounted() {
    this.getData();
    this.getBackReson();
  },
  methods: {
    getData() {
      //获取对应的工单信息
      request({
        url: api.soOrder.getDataUrl,
        method: 'post',
        data: {
          id: this.dataId
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.formData = response.data.data;
      })
    },
    getBackReson() {
      request({
        url: '/basic/basReturnType/getLists',
        method: 'post',
        data: {
          usable: 1,
          returnDisrect:1,
          orderId: this.dataId
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.returnData = response.data.data;
      })
    },
    radioHandleChange(){
      if(this.formData.acceptValue==1){
        this.refuseOrderReasonShow = false;
      }else {
        this.refuseOrderReasonShow = true;
      }
    },
    getDispatch(){
      request({
        url: api.basDispatchStat.getList,
        method: 'post',
        data:{showInRemark:this.showInRemark,orderId:this.dataId},
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.dispatchStats = response.data.data
      })
    },
    orderFollowUp() {
      // if(!this.formData.acceptValue){
      //   this.$message({message: '请先选择是否接单', type: 'warning'});
      //   return;
      // }
      if(!this.formData.returnId){
        this.$message({message: '请选择退单原因', type: 'warning'});
        return;
      }
      if(this.formData.remark==null||this.formData.remark==''){
        this.$message({message: '请填写备注', type: 'warning'});
        return;
      }
      let returnName =  this.$refs.returnId.selected.label;
      this.formData.returnName = returnName;

      this.$mask.open()
      request({
        // url: api.soOrder.siteAcceptUrl,
        url:api.soOrder.siteAcceptUrl,
        method: 'post',
        data: {
          id: this.formData.id,
          acceptValue:1,
          refuseOrderReason:this.formData.refuseOrderReason,
          returnId:this.formData.returnId,
          remark:this.formData.remark,
          returnName:this.formData.returnName
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if(response.data.type == "success"){
          this.$message({ message:response.data.content,type: 'success'});
          this.drawer = false;
          clearTimeout(this.timer);
          this.$emit('closedispatchedAccept', 1)
        }else{
          this.$message({ message:response.data.content,type: 'warning'});
        }
      })
      this.$mask.close()
    },
    cancelForm() {
      this.drawer = false;
      clearTimeout(this.timer);
      this.$emit('closedispatchedAccept', 0)
    },
    handleClose() {
      this.drawer = false;
      this.$emit('closedispatchedAccept', 0)
    }
  }
}
</script>
<style lang="scss" scoped>
.details2{

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }
  //   3个标签
  .information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }
  //   每个分支
  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }
    .table-detail tr {
      margin-bottom: 10px;
      display: block;
      th {
        font-weight: 400;
        text-align: right;
        width: 7vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 5px 0 4px;
        color: rgba(86, 86, 86, 0.96);
      }
      td {
        font-weight: 400;
        // text-align: right;
        width: 10vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 0px 0 4px;
        color: rgba(0, 0, 0,);
      }
    }}

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space:nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }
  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }
  ::v-deep  .el-step__title {
    font-size: 13px!important;
    line-height: 38px;
  }
}
</style>
